import React from 'react';
import FactorSelection from "../FactorSelection";
import { QRDialog } from "../QRDialog";
import { useAppSelector } from "../../store/hooks";
import PxCaptcha from "../Captcha/PxCaptcha";
import GeneralError from "../FeedbackModals/GeneralError";
import Notification from "../FeedbackModals/Notification";
export var Router = function Router() {
  var currentRoute = useAppSelector(function (state) {
    return state.router.current_route;
  });
  switch (currentRoute) {
    case 'push_sent':
      return /*#__PURE__*/React.createElement(Notification, {
        variant: "notification_sent"
      });
    case 'general_error':
      return /*#__PURE__*/React.createElement(GeneralError, null);
    case 'os_push_declined':
      return /*#__PURE__*/React.createElement(Notification, {
        variant: "os_push_declined"
      });
    case 'app_push_declined':
      return /*#__PURE__*/React.createElement(Notification, {
        variant: "app_push_declined"
      });
    case 'qr':
      return /*#__PURE__*/React.createElement(QRDialog, null);
    case 'timeout':
      return /*#__PURE__*/React.createElement(QRDialog, {
        variant: "timeout"
      });
    case 'px':
      return /*#__PURE__*/React.createElement(PxCaptcha, null);
    default:
      return /*#__PURE__*/React.createElement(FactorSelection, null);
  }
};